import { Heading, Paragraph } from '@/components/atoms';
import { TrendingUpIcon, CalendarIcon, UserIcon } from 'lucide-react';

interface MetricCardProps {
  title: string;
  value: string;
  subtitle?: string;
  icon: 'trending' | 'calendar' | 'user';
  showEmpty: boolean;
}

export const MetricCard = ({
  title,
  value,
  subtitle,
  icon,
  showEmpty,
}: MetricCardProps) => {
  const getIcon = () => {
    switch (icon) {
      case 'trending':
        return <TrendingUpIcon className="w-4 h-4 text-yellow-600" />;
      case 'calendar':
        return <CalendarIcon className="w-4 h-4 text-yellow-600" />;
      case 'user':
        return <UserIcon className="w-4 h-4 text-gray-600" />;
      default:
        return <TrendingUpIcon className="w-4 h-4 text-yellow-600" />;
    }
  };

  return (
    <div className="bg-white rounded-md border border-accent shadow-sm p-4">
      <div className="flex items-center justify-between">
        <div className="flex flex-col gap-2">
          <Heading size="sm" className="text-gray-400 mb-1">
            {title}
          </Heading>
          <div className="text-2xl font-bold">{showEmpty ? '----' : value}</div>
          {subtitle && (
            <Paragraph size="xs" className="text-gray-500">
              {showEmpty ? '----' : subtitle}
            </Paragraph>
          )}
        </div>
        <div className="w-8 h-8 bg-yellow-100 rounded-full flex items-center justify-center">
          {getIcon()}
        </div>
      </div>
    </div>
  );
};
